import dayjs from 'dayjs';
import { CreneauType } from '../../app.constants';
import { Pointage } from '../creneaux/pointage.model';
import { DeclarationPosition } from './declaration-position.model';
import { Declaration } from './declaration.model';

export class VacationRonde {
  constructor(
    public id?: string,
    public anomalies: Declaration[] = [],
    public positionsDeclarees: DeclarationPosition[] = [],
    public passages: dayjs.Dayjs[] = [],
    public type = CreneauType.RONDE,
    public pointages: Pointage[] = []
  ) {}

  public static hydrate(vacation: VacationRonde): VacationRonde {
    return new VacationRonde(
      vacation.id,
      vacation.anomalies?.map(Declaration.hydrate) ?? [],
      // vacation.infos?.map(Declaration.hydrate) ?? [],
      vacation.positionsDeclarees?.map(DeclarationPosition.hydrate) ?? [],
      vacation.passages?.map(a => dayjs(a)) ?? [],
      vacation.type,
      vacation.pointages?.map(Pointage.hydrate) ?? []
    );
  }
}
